// PreviewTable.jsx
import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const PreviewTable = ({ data , columnKeys, selectedRows, onSubmit }) => {

  if (!data || data.length === 0) {
    return <p className="text-gray-500 italic">Không có dữ liệu để xem trước.</p>;
  }

  const parsedData = [...selectedRows].map(i => {
    const row = data[i];
    return columnKeys.reduce((acc, key, idx) => {
      acc[key] = row[idx];
      return acc;
    }, {});
  });

  const confirm = () => {
    Modal.confirm({
      title: 'Xác nhận import dữ liệu',
      icon: <ExclamationCircleOutlined />,
      content: 'Bạn có chắc chắn thực hiện hành động này?',
      okText: 'Ok',
      cancelText: 'Huỷ',
      onOk: () => {
        onSubmit(parsedData);
      },
    });
  };

  return (
    <div className="overflow-x-auto max-h-[60vh] overflow-y-auto bg-white p-4 shadow border rounded">
      <button
        className="mt-4 px-4 py-2 bg-green-600 text-white rounded"
        onClick={confirm}
      >
        Import data
      </button>
      <table className="min-w-full table-auto border border-collapse border-gray-300">
        <thead className="bg-gray-200">
          <tr>
            {columnKeys.map((col) => (
              <th key={col} className="border p-2 text-left">{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {parsedData.map((row, rowIdx) => (
            <tr key={rowIdx} className="hover:bg-gray-50">
              {columnKeys.map((col) => (
                <td key={col} className="border p-2">{row[col]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PreviewTable;
